import type React from 'react'

import { cn } from '../lib/utils'

type TextProps = React.HTMLAttributes<HTMLParagraphElement> & {
    children?: React.ReactNode
    testId?: string
}

export const Subtitle = ({ className, ...props }: TextProps) => {
    return (
        <h2
            data-testid={props.testId ?? 'subtitle'}
            className={cn(
                'leading-[20px] text-center font-normal text-lp-dark1 text-[14px]',
                className,
            )}
            {...props}
        >
            {props.children}
        </h2>
    )
}
